import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getIsChargerCompatibleWithAutoLock:
UseCase<ChargerRepository, 'getIsChargerCompatibleWithAutoLock'> = repository => {
  return async (charger) => {
    return await repository.getIsChargerCompatibleWithAutoLock(charger)
  }
}
